import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Routes, Route, useBlocker } from 'react-router-dom';

import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import Signup from '../pages/signup/Signup';
import Home from '../pages/home/Home';
import Login from '../pages/home/Login';
import AddKey from '../pages/local/AddKey';
import PageNotFound from '../pages/common/PageNotFound';
import Terms from '../pages/terms/Terms';
import Privacy from '../pages/terms/Privacy';
import useGlobal from '../store';
import getI18nService from '../i18n/i18n';

const i18n = getI18nService();

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: `calc(100vh - 80px)`,
    paddingBottom: '50px',
  },
}));

const karnakEnv = window['KARNAK_ENV'];

function HomePageLayout({ config }) {
  const classes = useStyles();
  const [globalState, globalActions] = useGlobal();
  const serviceUri = config ? config.serviceUri : '';
  const { isFormDirty, confirmationModal } = globalState;

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isFormDirty &&
      currentLocation.pathname !== nextLocation.pathname
  );

  useEffect(() => {
    if (blocker.state === 'blocked' && !confirmationModal.open) {
      globalActions.showConfirmationModal(
        i18n.t('Messages.unSavedChanges')
      );
    }
  }, [blocker.state, confirmationModal.open, globalActions]);

  useEffect(() => {
    if (!confirmationModal.open && blocker.state === 'blocked') {
      if (confirmationModal.confirmed) {
        globalActions.setIsFormDirty(false);
        globalActions.resetConfirmationModal();
        blocker.proceed();
      } else {
        blocker.reset();
      }
    }
  }, [
    confirmationModal.open,
    confirmationModal.confirmed,
    blocker,
    globalActions,
  ]);

  useEffect(() => {
    if (isFormDirty) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = null;
    }
  }, [isFormDirty]);

  return (
    <Box
      height="100%"
      flexGrow="1"
      className={classes.root}
      display="flex"
      overflow="visible"
      alignItems="center"
      data-id="karnakMainContainer"
      justifyContent="center"
    >
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        {karnakEnv && karnakEnv === 'eng' && (
          <Route path="/localdev" element={<AddKey />} />
        )}
        <Route
          path="/login"
          element={<Login serviceUrl={serviceUri} />}
        />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Box>
  );
}

HomePageLayout.propTypes = {
  config: PropTypes.object.isRequired,
};

export default HomePageLayout;
